import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Week } from './week';
import { App } from '../interfaces';
import { DateTime } from 'luxon';

export interface MonthProps {
  moment: DateTime;
  controller: App.Schedule.CalendarController
}

export class Month extends React.Component<MonthProps, undefined> {

  daysOfWeek(currentDay: DateTime) {

    let currentDayOfWeek = currentDay.startOf('week', { useLocaleWeeks: true });
    const daysOfWeek = [];
    const lastDayOfWeek = currentDay.endOf('week', { useLocaleWeeks: true});

    while(currentDayOfWeek < lastDayOfWeek) {

      daysOfWeek.push(<div className="month__days-of-week__day-of-week" key={ currentDayOfWeek.ordinal }>{ currentDayOfWeek.toFormat('EEEE') }</div>);

      currentDayOfWeek = currentDayOfWeek.plus({ days: 1 });

    }

    return daysOfWeek;

  }

  render() {

    const lastDayOfMonth = this.props.moment.endOf('month', { useLocaleWeeks: true }).endOf('week', { useLocaleWeeks: true });
    let currentWeek = this.props.moment.startOf('month', { useLocaleWeeks: true }).startOf('week', { useLocaleWeeks: true });

    const numberOfWeeks = Math.ceil(lastDayOfMonth.diff(currentWeek, 'days').days / 7);

    const weeks = [];

    for (let i = 0; i < numberOfWeeks; i++) {
      weeks.push(<Week key={currentWeek.ordinal} moment={currentWeek} controller={this.props.controller} />);
      currentWeek = currentWeek.plus({ weeks: 1 });
    }

    return <div className={ 'month' }>
      <div className="month__days-of-week">{ this.daysOfWeek(this.props.moment) }</div>
      { weeks }
    </div>;

  }


}


// WEBPACK FOOTER //
// ./resources/src/components/schedule/month.tsx